// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2T6X9","footer":"ModalFilter_footer__3pfJt"};